import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { apiAction } from '../../store/generalSlice';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import Spinner from '../../layout/Spinner';
import { parseSentence } from '../../utils/helpers';

const TestChecker = () => {
  const dispatch = useDispatch();
  const { condition_id, sub_condition_id, checker_id } = useParams();
  const { checkResult } = useSelector((state) => state.general);
  const [searchText, setSearchText] = React.useState('');
  const [filteredRows, setFilteredRows] = React.useState([]);
  console.log({ checkResult });
  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'checkResult',
        route: `conditions/testConditionChecker`,
        conditionId: condition_id,
        subConditionId: sub_condition_id,
        checkerId: checker_id,
      })
    );
  }, []);

  useEffect(() => {
    if (checkResult?.calculatedResults) {
      setFilteredRows(checkResult.calculatedResults);
    }
  }, [checkResult]);

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);
    const filtered = checkResult.calculatedResults.filter((row) =>
      Object.values(row).some((val) => String(val).toLowerCase().includes(value))
    );
    setFilteredRows(filtered);
  };

  const columns = [
    {
      field: 'sentence',
      headerName: 'Sentence',
      width: 200,
    },
    {
      field: 'calculatedSentence',
      headerName: 'Calculated Sentence',
      width: 200,
      renderCell: (params) => <span style={{ color: params.value ? 'green' : 'red' }}>{params.value.toString()}</span>,
    },
    ...Object.keys(checkResult?.calculatedResults?.[0] || {})
      .filter((key) => key !== 'sentence' && key !== 'calculatedSentence')
      .map((key) => ({
        field: key,
        headerName: key.replace(/_/g, ' ').toUpperCase(),
        width: 150,
      })),
  ];

  return checkResult && checkResult.checker && checkResult.condition && checkResult.subCondition ? (
    <div data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
        <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0 border-bottom'>
          <h1>Checker Results</h1>
        </div>
        <div className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0'>
          <span>
            <h5>{checkResult.checker.name}</h5>
          </span>
        </div>
        <div className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0 border-bottom'>
          <Link to={`/condition/${checkResult.condition._id}`}>
            <h6>{checkResult.condition.name}</h6>
          </Link>{' '}
          <span className='ml-2 mr-2'>
            <h6> | </h6>
          </span>
          <Link to={`/subcondition/${checkResult.condition._id}/${checkResult.subCondition._id}`}>
            <h6>{checkResult.subCondition.name}</h6>
          </Link>
        </div>
        <div className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0'>
          <b className='text-info mr-2'>Checker Sentence: </b>
          <span>{parseSentence(checkResult.checker.sentence, checkResult.condition, checkResult.subCondition)}</span>
        </div>
        <div className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0 border-bottom'>
          Found {checkResult.calculatedResults.length} results
        </div>
      </div>
      {(() => {
        const entries = Object.entries(checkResult.calculatedResults);
        return (
          <>
            <Box style={{ height: 400, width: '100%' }}>
              <DataGrid
                rows={entries.map((entry, i) => ({ id: i, ...entry[1] })) || []}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                // checkboxSelection
                disableSelectionOnClick
              />
            </Box>
          </>
        );
      })()}
    </div>
  ) : (
    <Spinner />
  );
};

export default TestChecker;
